// src/utils/richTextDisplay.js
// The task summary / question breakdown text boxes switched from plain
// textareas to a Tiptap rich text editor, which emits HTML. Values saved
// before that change are plain strings with literal \n line breaks, not
// HTML - render those as if they were still plain text (escape + convert
// newlines to <br>) rather than dumping raw newlines into an HTML container,
// where they'd just collapse into nothing.

export function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function toDisplayHtml(text) {
  const looksLikeHtml = /<[a-z][\s\S]*>/i.test(text);
  if (looksLikeHtml) return text;
  return escapeHtml(text).replace(/\n/g, '<br>');
}
